import { render } from "./CoursesSelectionModal.vue?vue&type=template&id=502a6a8e&scoped=true"
import script from "./CoursesSelectionModal.vue?vue&type=script&lang=js"
export * from "./CoursesSelectionModal.vue?vue&type=script&lang=js"

import "./CoursesSelectionModal.vue?vue&type=style&index=0&id=502a6a8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502a6a8e"]])

export default __exports__